/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PodcastContentP } from './podcastContentP';
import { PodcastGroupP } from './podcastGroupP';
import { Timestamp } from './timestamp';


export interface PodcastP { 
    createdById?: number;
    createdByName?: string;
    creationDate?: Timestamp;
    date?: Timestamp;
    description?: string;
    id?: number;
    lastUpdateById?: number;
    lastUpdateByName?: string;
    lastUpdateDate?: Timestamp;
    orderNo?: number;
    podcastContents?: Array<PodcastContentP>;
    podcastGroupPs?: Array<PodcastGroupP>;
    posterUrl?: string;
    publishDate?: Timestamp;
    publishPoint?: PodcastP.PublishPointEnum;
    speakers?: Array<string>;
    status?: string;
    title?: string;
}
export namespace PodcastP {
    export type PublishPointEnum = 'Production' | 'Test';
    export const PublishPointEnum = {
        Production: 'Production' as PublishPointEnum,
        Test: 'Test' as PublishPointEnum
    };
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/podcast-content-client-api/model/podcastP.ts